// extracted by mini-css-extract-plugin
module.exports = {"numbersSection":"numbers-section-module--numbers-section--3J1Ev"};